import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MediumEditorDirective } from 'angular2-medium-editor/medium-editor.directive';



@NgModule({
    imports: [

    ],
    declarations: [
        MediumEditorDirective
    ],
    entryComponents: [],
    exports: [
        MediumEditorDirective
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class MediumEditorDirectiveModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/mediumEditor/mediumEditor.module.ts